// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"75334629","219":"b4d27c66","229":"a87d82fc","385":"cdb530a8","682":"8bddf89f","769":"6f0a9291","782":"36326714","787":"002b39e1","977":"2a86ea17"}[chunkId] + ".chunk.js";
};